import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Box, Divider, Grid, Typography } from '@material-ui/core';

import i18n from '../../i18n';

import '../../assets/stylesheets/BookingForm.css';

class SpecialProjectInfo extends Component {
  render() {
    const { specialProject } = this.props;

    // To prevent a hard crash if special project is empty but location is assigned.
    const projectName = specialProject
      ? specialProject.specialProjectName
      : i18n.t('noData');

    const startDate = specialProject
      ? specialProject.startDate
      : i18n.t('noData');

    const endDate = specialProject ? specialProject.endDate : i18n.t('noData');

    const notes = specialProject ? specialProject.notes : i18n.t('noData');

    return (
      <>
        <Grid item xs={3} className="bookingFormLabel">
          <Typography component="div">
            <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
              {i18n.t('specialProject:projectName')}
            </Box>
          </Typography>
        </Grid>
        <Grid item xs={8} className="bookingFormLabel ssenseLowWarning buttonRadius">
          <p className="bookingStaticField">{projectName}</p>
        </Grid>
        <Grid item xs={3} className="bookingFormLabel">
          <Typography component="div">
            <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
              {i18n.t('specialProject:startDate')}
            </Box>
          </Typography>
        </Grid>
        <Grid item xs={3} className="bookingFormLabel">
          <p className="bookingStaticField">{startDate}</p>
        </Grid>
        <Grid item xs={2} className="bookingFormLabel">
          <Typography component="div">
            <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
              {i18n.t('specialProject:endDate')}
            </Box>
          </Typography>
        </Grid>
        <Grid item xs={3} className="bookingFormLabel">
          <p className="bookingStaticField">{endDate}</p>
        </Grid>
        <Grid item xs={3} className="bookingFormLabel">
          <Typography component="div">
            <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
              {i18n.t('specialProject:notes')}
            </Box>
          </Typography>
        </Grid>
        <Grid item xs={8} className="bookingFormLabelNotes ssenseLowWarning buttonRadius">
          {notes.split('\n').map(item => {
            return (
              <React.Fragment key={item}>
                <span>{item}</span>
                <br />
              </React.Fragment>
            );
          })}
        </Grid>
        <Grid item xs={12}>
          <Divider className="form-divider" />
        </Grid>
      </>
    );
  }
}

SpecialProjectInfo.propTypes = {
  specialProject: PropTypes.oneOfType([PropTypes.shape([PropTypes.string, PropTypes.number]), PropTypes.bool])
};

SpecialProjectInfo.defaultProps = {
  specialProject: false
};

export default SpecialProjectInfo;
